import React, { useState } from 'react';
import Modal from 'sharedComponents/Modal'
import style from './style.module.scss'
import classNames from 'classnames';
import { UpdatedButton as Button } from 'components/Forms'

function DowngradePopup(props) {
  const [isOpen, setIsOpen] = useState(true);

  const handleClose = () => {
    setIsOpen(false);
    props.history.push('/')
  };

  if (!isOpen) return null;

  return (
    <Modal
      onClose={handleClose}
      className={classNames(style.wrapper)}
      disableClickOffToClose
    >
      <div>
        <div className={classNames(style.modal_content)}>
          <p>Intellitag & its replacement is only offered under the Pet Notify premium plan.</p>
          <Button 
            to='/settings/upgrade'
            className={style.button}
          >
            Upgrade to premium
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default DowngradePopup;